'use client';

import IPL_LOGO from '../../../public/assets/images/IPL_Logo_Text_White_SmallScale.png';
import SQX_white_logo from '../../../public/assets/images/SQXBondsWihteLogo.png';

const LOGO_FACEBOOK = '/assets/images/logo-facebook.svg';
const LOGO_INSTAGRAM = '/assets/images/logo-instagram.svg';
const LOGO_LINKEDIN = '/assets/images/logo-linkedin.svg';
const LOGO_TWITTER = '/assets/images/logo-twitter.svg';

import { EXIST_LOCAL_STORAGE } from '@/services/constants';
import { getCookie } from '@/services/helperFunctions';
import dynamicImporter from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import React, { memo, Suspense, useEffect, useState } from 'react';

const Support = dynamicImporter(() => import('../common/Support'), { ssr: false, loading: () => null });

const Footer = () => {
    const pathname = usePathname();
    const [showSupportForm, setShowSupportForm] = useState(false);
    const userId = getCookie(EXIST_LOCAL_STORAGE.USER_ID);
    const [currentYear, setCurrentYear] = useState<number | null>(null);

    useEffect(() => {
        setCurrentYear(new Date().getFullYear());
    }, []);
    return (
        <footer
            className=" text-lg-start px-3 fixed-bottom"
            style={{ backgroundColor: '#233e68', height: 'max-content', zIndex: 99999999 }}
        >
            <div className="container-fluid px-3 row-12" style={{ paddingTop: '2' }}>
                <div className="row px-1 px-sm-0">
                    <div className="col-12 col-sm-8 col-md-9 p-0 my-auto">
                        <div className="d-flex align-items-center">
                            <Link href="/" className="shibui-logo me-2 mb-md-0  text-decoration-none lh-1">
                                <Image
                                    loading="lazy"
                                    className="img-responsive footer-logo"
                                    alt="SQX-white-logo"
                                    width={90}
                                    height={20}
                                    src={SQX_white_logo}
                                    // style={{ objectFit: 'cover' }}
                                    unoptimized
                                />
                            </Link>
                            <span className="footer-text mb-md-0 text-white">
                                © {currentYear} SQX BONDS. All rights reserved |{' '}
                                <Link
                                    href="/privacy-policy"
                                    className="text-white text-decoration-underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Privacy Policy"
                                >
                                    Privacy Policy
                                </Link>{' '}
                                |{' '}
                                <Link
                                    href="/terms-and-condition"
                                    className="text-white text-decoration-underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Terms and Conditions"
                                >
                                    Terms and Conditions
                                </Link>{' '}
                                |{' '}
                                <Link
                                    href="/partners"
                                    className="text-white text-decoration-underline"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    aria-label="Represent a financial institution?"
                                >
                                    Represent a financial institution?
                                </Link>{' '}
                                {!pathname.includes('/admin_panel') && !pathname.includes('/discussion') && (
                                    <React.Fragment>
                                        <span> | </span>
                                        <span
                                            className="text-decoration-underline cursor-pointer"
                                            onClick={() => setShowSupportForm(!showSupportForm)}
                                        >
                                            Customer Support
                                        </span>
                                        <Suspense>
                                            {!!userId && (
                                                <Support showSupportForm={showSupportForm} setShowSupportForm={setShowSupportForm} />
                                            )}
                                        </Suspense>
                                    </React.Fragment>
                                )}
                            </span>
                        </div>
                    </div>
                    <div className="footer-images col-12 col-sm-4 col-md-3 p-0 justify-content-end align-items-center d-flex gap-lg-1">
                        <a
                            className="text-decoration-none lh-1 "
                            href="https://www.linkedin.com/company/sqxbonds/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="linkedin-logo"
                        >
                            <Image
                                loading="lazy"
                                alt="Visit SQXBonds on linkedin"
                                className="img-responsive footer-logo object-fit-cover"
                                width={22}
                                height={22}
                                src={LOGO_LINKEDIN}
                            />
                            <span className="visually-hidden">Visit SQXBonds on LinkedIn</span>
                        </a>
                        <a
                            className="text-decoration-none lh-1 "
                            href="https://www.facebook.com/profile.php?id=100092449088794"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="facebook-logo"
                        >
                            <Image
                                loading="lazy"
                                alt="Visit SQXBonds on facebook"
                                className="img-responsive footer-logo object-fit-cover"
                                width={24}
                                height={24}
                                src={LOGO_FACEBOOK}
                            />
                            <span className="visually-hidden">Visit SQXBonds on LinkedIn</span>
                        </a>
                        <a
                            className="text-decoration-none lh-1 "
                            href="https://www.instagram.com/sqxbonds/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="instagram-logo"
                        >
                            <Image
                                loading="lazy"
                                alt="Visit SQXBonds on instagram"
                                className="img-responsive footer-logo object-fit-cover"
                                width={24}
                                height={24}
                                src={LOGO_INSTAGRAM}
                            />
                            <span className="visually-hidden">Visit SQXBonds on LinkedIn</span>
                        </a>
                        <a
                            className="text-decoration-none lh-1 "
                            href="https://x.com/SQXBonds"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="twitter-logo"
                        >
                            <Image
                                loading="lazy"
                                alt="Visit SQXBonds on twitter"
                                className="img-responsive footer-logo object-fit-cover "
                                width={20}
                                height={20}
                                src={LOGO_TWITTER}
                            />
                            <span className="visually-hidden">Visit SQXBonds on LinkedIn</span>
                        </a>
                        <a
                            className="text-decoration-none lh-1 ipl-img"
                            href="https://information-publishing.com/"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="ipl-logo"
                        >
                            <Image
                                loading="lazy"
                                alt="Visit SQXBonds on ipl"
                                className="img-responsive footer-logo ms-1 ms-sm-4 object-fit-cover"
                                width={50}
                                height={50}
                                src={IPL_LOGO}
                                unoptimized
                            />
                            <span className="visually-hidden">Visit SQXBonds on LinkedIn</span>
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default memo(Footer);
